import { ComponentType } from 'react';

import './Header.module.css';
import logo from '../logo.png';

export const Header: ComponentType = () => (
  <header>
    <img alt="Stag Emporium logo" src={logo} />
    <span>Develop</span>
    <span>User Management</span>
  </header>
);
